import React from 'react';
import useStore from '../store/useStore';

const CustomerServiceButton = () => {
  const user = useStore((state) => state.user);

  const handleClick = () => {
    if (typeof window.A10Support !== 'function') {
      console.error('A10 Support is not loaded');
      return;
    }

    const userId = String(user?.playerid || user?.id || '');
    const userName = user?.name || '';
    const metadata = {
      email: user?.email || '',
      fpid: String(user?.id || ''),
      playerid: String(user?.playerid || ''),
      level: user?.Level || 0,
      vip: user?.VipLevel || 0,
      page: 'payment',
    };

    window.A10SupportConfig = Object.assign({}, window.A10SupportConfig || {}, {
      userId,
      userName,
      metadata,
    });

    if (!window.__A10_SUPPORT_INITIALIZED__) {
      window.A10Support('init', window.A10SupportConfig);
      window.__A10_SUPPORT_INITIALIZED__ = true;
    } else if (typeof window.A10Support.identify === 'function') {
      window.A10Support.identify({ userId, userName, metadata });
    }

    window.A10Support('open');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title="Customer Service"
      className="fixed bottom-4 right-4 z-[1000] flex h-12 w-12 items-center justify-center rounded-full bg-gold text-night shadow-glow transition hover:scale-110 hover:brightness-105 sm:bottom-6 sm:right-6 sm:h-14 sm:w-14"
    >
      <svg className="h-5 w-5 sm:h-6 sm:w-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97C9.02 21.64 10.46 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.29 0-2.52-.3-3.61-.84l-.26-.14-2.68.79.79-2.68-.14-.26C5.57 15.83 4 13.99 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm4.25-6.03c-.23-.12-1.36-.67-1.57-.75s-.36-.12-.52.12-.59.75-.73.9-.27.17-.5.06c-.23-.12-.97-.36-1.85-1.14-.68-.61-1.14-1.36-1.28-1.59s-.01-.35.1-.47c.1-.1.23-.27.35-.41.11-.14.15-.23.23-.38s.04-.29-.02-.41c-.06-.12-.52-1.25-.71-1.71-.19-.45-.38-.39-.52-.4h-.45c-.15 0-.41.06-.62.29s-.82.8-.82 1.95.84 2.27.96 2.42c.12.16 1.65 2.52 4 3.53.56.24 1 .38 1.34.49.56.18 1.07.15 1.47.09.45-.07 1.36-.56 1.55-1.1s.19-.99.14-1.1c-.06-.1-.22-.16-.46-.28z"/>
      </svg>
    </button>
  );
};

export default CustomerServiceButton;
